<template>
  <div class="register" v-if="step1">
    <div class="box">
      <van-cell-group class="fx fx-items-center country-group" @click="onCountryTap">
        <van-field
          left-icon="location"
          v-model="registerParams.country"
          placeholder="Choose country"
        />
        <van-icon color="#ccc" name="arrow" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-if="phoneCode"
          left-icon="https://ebuyimg.e-mallchina.com/olvp/phone.png"
          v-model="registerParams.phone"
          placeholder="Phone number"
          type="tel"
          :label="phoneCode ?'+' + phoneCode : ''"
          @input="onPhoneTap"
          @focus="focus"
          @blur="blur"
          :error-message="errPhone ? 'Phone number format is not correct.' : ''"
        />
        <van-field v-else
          left-icon="https://ebuyimg.e-mallchina.com/olvp/phone.png"
          v-model="registerParams.phone"
          placeholder="Phone number"
          type="tel"
          disabled
          @click="inputTap"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="verifyParams.smsCode"
          left-icon="https://ebuyimg.e-mallchina.com/olvp/sms.png"
          center
          type="tel"
          @focus="focus"
          @blur="blur"
          clearable
          placeholder="Verification Code in SMS"
        >
          <template #button v-if="step1">
            <van-button size="small" type="primary" color="#1989fa" @click="onSendTap" :disabled="showCountDown || !registerParams.phone || errPhone">
              <span v-if="!showCountDown">Send</span>
              <van-count-down v-else :time="time" format="ss s" @finish="finish"/>
            </van-button>
          </template>
        </van-field>
      </van-cell-group>
      <van-button class="register-btn" round type="info" size="large" :disabled="!registerParams.phone || errPhone || !verifyParams.smsCode" @click="onNextTap">
        {{this.registerParams.platformName === 'sms' ? 'Next Step' : 'Sign In'}}
      </van-button>
    </div>
    <van-dialog v-model="tipsDialog" @confirm="onRulesConfirm" :close-on-popstate="true">
      <div class="tips-content">
        <!-- <p v-html="rulesData"></p> -->
        <data-privacy v-if="dialogType === 'Privacy'"></data-privacy>
        <data-conditions v-else></data-conditions>
      </div>
    </van-dialog>
     <!-- :style="{'position': showRule ? 'absolute': 'static'}" -->
    <div class="rule-box t-c" v-show="showRule">
      <p class="gray text-center">By signing in here you agree to the</p>
      <p class="gray text-center">
        <span class="bold" style="text-decoration: underline" @click="onRulesTap('conditions')">Terms and Conditions</span> and <span class="bold" style="text-decoration: underline" @click="onRulesTap('privacy')">Privacy Policy</span>
      </p>
    </div>
  </div>
  <div class="register" v-else>
    <div class="box">
      <p class="user">Phone Number <span class="bold">(+{{phoneCode}}) {{registerParams.phone}}</span></p>
      <p class="err gray">
        Password must be between 6-20 characters and include at least 2 of the following: digits, alphabets or symbols.
      </p>
      <van-cell-group class="fx fx-items-center">
        <van-field
          left-icon="lock"
          v-model="registerParams.password"
          placeholder="Enter the password"
          @input="onPasswordTap"
          maxlength="20"
          :type="firstWordType"
          :error-message="errWord ? 'Password format is not correct.' : ''"
        />
        <van-icon v-if="firstWordType === 'password'" name="closed-eye" size="18" @click="changePassType('first')"  />
        <van-icon v-else name="eye-o" size="18" @click="changePassType('first')"  />
      </van-cell-group>
      <van-cell-group class="fx fx-items-center">
        <van-field
          left-icon="lock"
          v-model="passwordAgain"
          placeholder="Enter the password again"
          @input="onPasswordAgainTap"
          maxlength="20"
          :type="againWordType"
          :disabled="!registerParams.password"
          :error-message="passwordAgain && registerParams.password && (passwordAgain != registerParams.password) ? 'Confirm password does not match.' : ''"
        />
        <van-icon v-if="againWordType === 'password'" name="closed-eye" size="18" @click="changePassType('again')" />
        <van-icon v-else name="eye-o" size="18" @click="changePassType('again')" />
      </van-cell-group>
      <van-button v-if="initType === 'reg'" class="register-btn" round type="info" size="large" :disabled="errWord || (registerParams.password && passwordAgain != registerParams.password)" @click="onConfirmTap">
        {{registerParams.platformName === 'sms' ? 'Sign-up' : 'Binding phone number'}}
      </van-button>
      <van-button v-else class="register-btn" round type="info" size="large" :disabled="errWord || (registerParams.password && passwordAgain != registerParams.password)" @click="onResetTap">
        Reset password
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      initType: '',
      showCountDown: false,
      time: 60000,
      step1: true,
      checked1: true,
      errWord: false,
      errPhone: false,
      passwordAgain: '',
      registerParams: {
        phone: '',
        password: '',
        platformName: '',
        country: '',
        profilePhotoUrl: '',
        thirdAppId: '',
        memberName: '',
        memberSource: ''
      },
      tipsDialog: false,
      rulesData: '',
      dialogType: '',
      phoneCode: '',
      firstWordType: 'password',
      againWordType: 'password',
      verifyParams: {
        phone: '',
        smsCode: ''
      },
      showRule: true,
      loginParams: {
        password: '',
        phone: '',
        country: '',
        bindingAccount: '',
        platformName: 'facebook'
      }
    }
  },
  created () {
    const queryParams = this.$route.query
    const country = this.$util.storageGet('local', 'country') || 'Choose country'
    console.log(country)
    const name = this.$util.storageGet('local', 'name') || ''
    this.phoneCode = this.$util.storageGet('local', 'phoneCode') || ''
    this.initType = queryParams.type // 注册or重置密码

    this.registerParams.country = country
    this.registerParams.platformName = queryParams.platform || 'sms'
    this.registerParams.profilePhotoUrl = this.$util.storageGet('local', 'picture')
    this.registerParams.memberName = name
    this.registerParams.thirdAppId = queryParams.fbId || ''
    this.registerParams.memberSource = this.$util.storageGet('local', 'memberSource') || ''
  },
  methods: {
    // 登录
    newOlvpLogin (params) {
      return this.$http.post('/olvp/newOlvpLogin', 'newOlvpLogin', params, false, false)
    },
    // 发送短信验证码
    smsSend (params) {
      return this.$http.post('/olvp/smsSend', 'smsSend', params, true, false, false)
    },
    // 校验短信验证码
    verifySmsCode (params) {
      return this.$http.post('/olvp/verifySmsCode', 'verifySmsCode', params, true, false, false)
    },
    // 注册
    newRegister (params) {
      return this.$http.post('/olvp/newRegister', 'newRegister', params, true, false, false)
    },
    // 重置密码
    resetPassword (params) {
      return this.$http.post('/olvp/resetPassword', 'resetPassword', params, false, false, false, false)
    },
    backHome () {
      this.$router.replace('/home')
    },
    checkPhoneNumber (phoneNumber) {
      const reg = this.$pattern.phonei18n
      let num = 0
      for (const key in reg) {
        const regx = reg[key]
        if (regx.test(phoneNumber)) {
          num++
        }
      }
      if (num === 0) {
        return false
      }
      return true
    },
    // 输入手机号
    onPhoneTap (e) {
      if (this.checkPhoneNumber(e)) {
        this.errPhone = false
      } else {
        this.errPhone = true
      }
    },
    inputTap () {
      this.$cux.toast('Please choose you country first.')
    },
    // 选择国家
    onCountryTap () {
      const path = this.$route.fullPath
      this.$router.push(`/country?backPath=${encodeURIComponent(path)}`)
    },
    // 发送短信验证码
    onSendTap () {
      if (!this.registerParams.phone) {
        // this.$cux.toast('请填写手机号')
        return false
      }
      const params = {
        phone: this.phoneCode + '+' + this.registerParams.phone
      }
      this.smsSend(params).then((d) => {
        if (d.success) {
          this.showCountDown = true
          this.$cux.toast({
            message: 'SMS with verification code has been sent to your phone.',
            type: 'success'
          })
        }
      })
    },
    finish () {
      this.showCountDown = false
    },
    // 用户协议
    onRulesTap (e) {
      this.dialogType = e
      this.tipsDialog = true
    },
    onRulesConfirm () {

    },
    focus () {
      this.showRule = false
    },
    blur () {
      this.showRule = true
    },
    // 返回登陆
    onLoginTap () {
      this.$router.replace(`/login?backPath=${encodeURIComponent(this.$route.query.backPath)}`)
    },
    // 下一步 校验短信验证码
    onNextTap () {
      if (this.registerParams.platformName === 'sms') {
        this.verifyParams.phone = this.registerParams.phone
        this.verifySmsCode(this.verifyParams).then((d) => {
          if (d.success) {
            if (d.content.success === 'true') {
              this.step1 = false
            } else {
              this.$cux.toast('Invalid validation code')
            }
          }
        })
      } else {
        // 三方授权 直接登录
        this.newRegister(this.registerParams).then((d) => {
          // 注册成功跳回进入页面 注册流程回登录 绑定流程回购买
          if (d.success) {
            /* eslint-disable no-undef */
            // fbq('track', 'CompleteRegistration')
            this.setNewGuest()
            this.loginParams.country = this.registerParams.country
            this.loginParams.phone = this.registerParams.phone
            this.loginParams.bindingAccount = this.registerParams.thirdAppId
            this.loginParams.platformName = this.registerParams.platformName
            this.newOlvpLogin(this.loginParams).then((d2) => {
              window._czc.push(['_trackEvent', '点击', '登陆'])
              if (d2.success) {
                if (d2.content.success === 'true') {
                  this.$util.storageSet('local', 'platform', this.loginParams.platformName)
                  this.$util.storageSet('local', 'phone', this.loginParams.phone)
                  this.$util.storageSet('local', 'token', d2.content.token)
                  this.$util.storageSet('local', 'picture', d2.content.profilePhotoUrl)
                  this.$util.storageSet('local', 'name', d2.content.memberName)
                  this.$util.storageSet('local', 'memberId', d2.content.memberId)
                  this.$router.replace(this.$route.query.backPath)
                }
              }
            })
          }
        })
      }
    },
    // 输入密码
    onPasswordTap (e) {
      // 至少包含字母数组符合其中两种
      let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/
      if (reg.test(e)) {
        this.errWord = false
      } else {
        this.errWord = true
      }
    },
    // 再次输入密码
    onPasswordAgainTap () {

    },
    // 注册
    onConfirmTap () {
      this.$cux.loading()
      this.newRegister(this.registerParams).then((d) => {
        // 注册成功跳回进入页面 注册流程回登录 绑定流程回购买
        this.$cux.loadend()
        if (d.success) {
          window._czc.push(['_trackEvent', '点击', '注册'])
          /* eslint-disable no-undef */
          // fbq('track', 'CompleteRegistration')
          this.$cux.toast({
            message: 'Registered successfully.',
            type: 'success'
          })
          this.setNewGuest()
          setTimeout(() => {
            this.onLoginTap()
          }, 1500)
        }
      })
    },
    // 重置密码
    onResetTap () {
      const params = {
        phone: this.registerParams.phone,
        password: this.registerParams.password
      }
      this.resetPassword(params).then((d) => {
        if (d.success) {
          this.$cux.toast({
            message: 'Reset password successfully.',
            type: 'success'
          })
          setTimeout(() => {
            this.onLoginTap()
          }, 1500)
        }
      })
    },
    changePassType (e) {
      if (e === 'first') {
        this.firstWordType = this.firstWordType === 'text' ? 'password' : 'text'
      } else {
        this.againWordType = this.againWordType === 'text' ? 'password' : 'text'
      }
    },
    setNewGuest () {
      this.$util.storageSet('local', 'isNewGuest', 'false')
    }
  }
}
</script>

<style lang="scss">
  .register {
    padding: 40px 0;
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    .country-group {
      .van-cell:not(:last-child)::after {
        border: none;
      }
    }
    .van-cell__title.van-field__label {
      font-weight: 500;
      width: 40px !important;
    }
    .t-c {
      width: 100%;
      position: absolute;
      bottom: 60px;
    }
    .van-count-down {
      text-align: center;
      color: #fff;
    }
    .van-dialog {
      width: 85% !important;
    }
    .tips-content {
      max-height: 70vh;
      overflow-y: scroll;
      padding: 20px;
      line-height: 25px;
    }
    .user {
      font-size: 18px;
    }
    .green {
      color: #07c160;
    }
    .box {
      margin: 0 auto;
      padding: 0 20px;
      .van-cell {
        align-items: center;
      }
      .err {
        font-size: 12px;
        margin: 10px 0;
      }
      .logo {
        width: 80px;
        height: 80px;
        margin: 0 auto;
        margin-bottom: 80px;
      }
      .van-icon {
        color: #388BFF;
      }
      .register-btn {
        margin-top: 30px;
      }
    }
    .other {
      margin-top: 20px;
      padding: 0 16px;
      .login-btn {
        margin-top: 20px;
      }
      .van-icon {
        font-size: 16px;
      }
      .rule-box {
        p {
          line-height: 20px;
          word-wrap: break-word;
        }
        span {
          text-decoration: underline
        }
      }
      .van-checkbox .van-checkbox__icon {
        border-radius: 3px;
        overflow: hidden;
      }
    }
  }
</style>
